import React from 'react'
import PropTypes from 'prop-types'
import Dollar from "../../../Assests/Dollar Coins.svg"
import './Price.css'

const Price = ({ rate, size, dollarSign }) => {
    return (
        <div className={`podcast_rate_status ${size}`}>
            {
                dollarSign && (
                    <img src={Dollar} />
                )
            }
            <div className="podcast-episode-rate">
                <span>$</span>
                <span>{rate ? rate : '-'}</span>
                <span>/Ep</span>
            </div>
        </div>
    )
}

Price.propTypes = {
    rate: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    size: PropTypes.string,
    dollarSign: PropTypes.bool,
};

export default Price
